import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import { compose } from 'recompose';
import { TableRow, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { timelineStepRow } from 'themes/colors';
import { ArrowBack } from '@material-ui/icons';
import Button from 'components/buttons/Button';
import moment from 'moment';
import { FULLDATE_FORMAT_SLASHES } from 'constants/config';


const SequenceTab = ({ classes, campaign, onBack }) => (
  <>
    <div className={classes.title}>
      <Button
        type="button"
        variant="text"
        onClick={onBack}
        startIcon={<ArrowBack />}
      >
        { campaign.name }
      </Button>
    </div>
    <Table className={classes.table}>
      <TableHead>
        <TableCell>Sequence</TableCell>
        <TableCell>First day of sending</TableCell>
        <TableCell>Last day of sending</TableCell>
      </TableHead>
      <TableBody>
        {campaign.sequences.map(sequence => (
          <>
            <TableRow>
              <TableCell>{sequence.name}</TableCell>
              <TableCell>{moment(sequence.start_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
              <TableCell>{moment(sequence.end_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
            </TableRow>
            {sequence.steps.map((step, index) => (
              <TableRow className={classes.stepRow}>
                <TableCell>{`Step ${index + 1}`}</TableCell>
                <TableCell>{moment(step.start_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
                <TableCell>{moment(step.end_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
              </TableRow>
            ))}
          </>
        ))}
      </TableBody>
    </Table>
  </>
);


SequenceTab.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  campaign: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    sequences: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      steps: {
        id: PropTypes.number,
        name: PropTypes.string,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
      },
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  onBack: PropTypes.func.isRequired,
};

const styles = theme => ({
  title: {
    marginBottom: '0.25rem',
    '& button, button:active, button:hover': {
      color: theme.palette.secondary.text,
      fontSize: '1rem',
      letterSpacing: '-0.2px',
    },
  },
  table: {
    '& th, td': {
      textAlign: 'center',
    },
    '& th:first-child, td:first-child': {
      textAlign: 'left',
    },
  },
  stepRow: {
    backgroundColor: timelineStepRow,
    '& td:first-child': {
      paddingLeft: '2rem',
    },
  },
});

export default compose(
  withStyles(styles),
  connect(state => ({ timelines: state.timelines })),
)(SequenceTab);
